/**
 * Merge default values for layer parameters (customProperties) into base properties.
 * Used when creating a new feature or 3D instance so keys match the layer schema.
 * Angle parameters have no default key (unset until the user sets a value); numeric
 * parameters default to null until set.
 */
export function mergeDefaultPropertiesForSchema(
  baseProps: Record<string, unknown>,
  schema: Array<{ name: string; type: string; options?: string[] }>,
): Record<string, unknown> {
  if (!schema.length) {
    return baseProps;
  }
  const result = { ...baseProps };
  for (const prop of schema) {
    if (!(prop.name in result)) {
      if (prop.type === 'angle') {
        continue;
      }
      result[prop.name] =
        prop.type === 'number'
          ? null
          : prop.type === 'boolean'
            ? false
            : prop.type === 'array' || prop.type === 'file'
              ? []
              : '';
    }
  }
  return result;
}
